// extracted by mini-css-extract-plugin
export default {"feed":"feed_feed__7wTIo","header":"feed_header__yPzzi","feedList":"feed_feedList__8whtX"};